<fieldset>
  <legend class="text-sm/6 font-semibold text-gray-900 flex gap-2">
    <div class="flex gap-1">
      {{ label }}
      <span *ngIf="is_required" class="text-red-500">*</span>
    </div>

    <p class="text-xs text-gray-500 mt-1 font-normal italic">{{sub_text}}</p>
  </legend>
  <!-- <p class="mt-1 text-sm/6 text-gray-600 dark:text-gray-400">Description if needed</p> -->
  <div class="mt-4" [ngClass]="{
      'space-y-4': layout === 'vertical',
      'flex flex-wrap gap-4': layout === 'horizontal',
      'pointer-events-none opacity-50': disabled
    }">
    <label *ngFor="let option of options" class="flex items-center cursor-pointer">
      <input [id]="option.value" type="radio" [name]="label" [value]="option.value" [checked]="option.value === value" (change)="select(option.value)" class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden" />
      <span class="ml-3 block text-sm/6 font-medium text-gray-900">
        {{ option.label }}
      </span>
    </label>
  </div>
  <div *ngIf="control && control.errors && (control.dirty || control.touched)" class="text-red-500 text-sm mt-1">
    <p *ngIf="control.errors['required']">{{ label }} is required.</p>
  </div>
</fieldset>